// js
import './js/global.js';
import './js/aos.js';
import './js/filtri-trattamenti.js';


import './js/product.js';
import './js/blog.js';
import './js/product-menu.js';
import './js/checkout.js';
import  './js/cart.js';
import  './js/forms.js';

import './js/slider.js';

import './js/menu.js';

import "./js/cf.js";

import './js/sticky-header.js';



// styles
import './scss/main.scss';